import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../authContext'; // Adjust the path as per your directory structure
import SignInModal from '../components/SignInModal';

const Login = () => {
    const { login } = useAuth();
    const navigate = useNavigate();

    // Define the function that handles sign-in
    const handleSignIn = async (email, password) => {
        try {
            await login(email, password);  // Log in and handle exceptions
            navigate('/admin');  // Navigate on successful login
        } catch (error) {
            console.error('Failed to log in:', error);
        }
    };

    return (
        <div>
            <h1>Login</h1>
            <SignInModal isOpen={true} onSignIn={handleSignIn} />
        </div>
    );
};

export default Login;
